// config/AuthApiEndpoints.js - Complete config file with all missing exports
// Import centralized API configuration
import { BASE_API, API_VERSION, API_BASE_URL } from './apiConfig';
 
// Re-export for backward compatibility
export { BASE_API, API_VERSION };
 
export const AUTH_API_BASE = `${API_BASE_URL}/auth`;
 
export const AUTH_ENDPOINTS = {
  BASE_URL: AUTH_API_BASE,
  // User Authentication
  GENERATE_OTP: `${AUTH_API_BASE}/generate/otp`,
  LOGIN: `${AUTH_API_BASE}/login`,
  // Token refresh endpoint
  REFRESH: `${AUTH_API_BASE}/refresh`,
  // User Management
  GET_USER: `${AUTH_API_BASE}/users/email`,
  getUserByEmail: (email) => `${AUTH_API_BASE}/users/email/${email}`,
  getUserOrganizations: (email) => `${BASE_API}/${API_VERSION}/users/email/${email}/organizations`,
  // Cognito/OAuth Callbacks
  COGNITO_CALLBACK: `${AUTH_API_BASE}/cognito/callback`,
  ACCEPT_INVITE: `${AUTH_API_BASE}/accept-invite`,
  // Domain-specific client endpoints
  DOMAIN_CLIENT: `${BASE_API}/api/domain-clients/domain-client`
};
 
// Cognito Configuration — env-driven; fallbacks are LOCAL DEV values only.
// CI injects the real values per environment (see .github/workflows/npm-publish-*.yml).
// The fallback is always dev on every branch — never another environment's value.
export const COGNITO_CONFIG = {
  COGNITO_DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || 'us-east-1fsko89hfx.auth.us-east-1.amazoncognito.com',
  CUSTOM_DOMAIN: process.env.REACT_APP_COGNITO_CUSTOM_DOMAIN || 'auth.dev.tonicsuite.io',
  IDENTITY_PROVIDERS: {
    MICROSOFT: 'TonicMicrosoftIdp',
    GOOGLE: 'Google'
  },
  DEFAULT_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '156q7nk25plrc610equ50hvks8',
  DEFAULT_REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || 'https://dev.tonicsuite.io/callback'
};
 
 
// Backward compatibility exports
export const GenerateOtp = AUTH_ENDPOINTS.GENERATE_OTP;
export const LoginWithOtp = AUTH_ENDPOINTS.LOGIN;